import React from 'react';
import {useRef} from "react";
import styles from './Main.module.scss';
import {motion,} from "framer-motion";
import arrow from "../../assets/images/icon/arrow.png";
import arrow2 from "../../assets/images/icon/arrow2.png";
import main_bg_1 from "../../assets/images/main/back_01.png";
import main_bg_1_mask from "../../assets/images/main/back_01_mask.png";
import main_bg_2 from "../../assets/images/main/back_02.png";
import main_bg_3 from "../../assets/images/main/background_02.png";
import main_bg_4 from "../../assets/images/main/background_03.png";
import platform_img from "../../assets/images/main/platform_img.png";
import icon_check_ye from "../../assets/images/icon/icon_check_ye.svg";
import icon_check_skbl from "../../assets/images/icon/icon_check_skbl.svg";
import icon_check_bk from "../../assets/images/icon/icon_check_bk.svg";
import alliance_01 from "../../assets/images/main/alliance_01.png";
import alliance_02 from "../../assets/images/main/alliance_02.png";
import alliance_03 from "../../assets/images/main/alliance_03.png";
import alliance_04 from "../../assets/images/main/alliance_04.png";
import alliance_05 from "../../assets/images/main/alliance_05.png";
import alliance_06 from "../../assets/images/main/alliance_06.png";
import alliance_07 from "../../assets/images/main/alliance_07.png";
import alliance_08 from "../../assets/images/main/alliance_08.png";
import alliance_09 from "../../assets/images/main/alliance_09.png";
import alliance_10 from "../../assets/images/main/alliance_10.png";
import dual_token_icon1 from "../../assets/images/icon/icon_dualtokens_01.svg";
import dual_token_icon2 from "../../assets/images/icon/icon_dualtokens_02.svg";
import dual_token_icon3 from "../../assets/images/icon/icon_dualtokens_03.svg";
import dual_token_icon4 from "../../assets/images/icon/icon_dualtokens_04.svg";
import icon_tokenreward_1 from "../../assets/images/icon/icon_tokenreward_01.svg";
import icon_tokenreward_2 from "../../assets/images/icon/icon_tokenreward_02.svg";
import icon_tokenreward_3 from "../../assets/images/icon/icon_tokenreward_03.svg";
import icon_tokenreward_4 from "../../assets/images/icon/icon_tokenreward_04.svg";
import icon_service_fee from "../../assets/images/icon/icon_service_fee.svg";
import icon_Alliance from "../../assets/images/icon/icon_Alliance.svg";
import icon_game from "../../assets/images/icon/icon_game.svg";
import icon_monthlydata from "../../assets/images/icon/icon_monthlydata.svg";
import icon_NFTmarketfee from "../../assets/images/icon/icon_NFTmarketfee.svg";
import img_phone from "../../assets/images/main/img_phone.png";
import { useTranslation } from 'react-i18next';

const Main = () => {
    const scrollRef = useRef(null);
    const platformCardVariants = {
        hidden: {opacity: 0, y: 100, rotateY: 300},
        visible: {
            opacity: 1,
            y: 0,
            rotateY: 0,
            transition: {
                rotateY: {
                    duration: 0.3
                },
                y: {
                    type: "spring",
                    damping: 3,
                    stiffness: 50,
                    restDelta: 0.01,
                    duration: 0.3
                }
            }
        }
    };
    const { t } = useTranslation();

    return (<div className={`${styles.Main}`}>
        <div className={styles.main_bg}>
            <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}} className={`container ${styles.main_box}`}>
                <h1 className={`text-start text-gradation-1`}>
                    Web 3.0 Platform
                </h1>
                <h1 className={`text-start text-gradation-2 py-0`}>
                    ONTEL
                </h1>
                <p className={`text-start lh-lg`}>
                    {t('text-start lh-lg-1')}<br/>
                    {t('text-start lh-lg-2')}<br/>
                    {t('text-start lh-lg-3')}<br/>
                    {t('text-start lh-lg-4')}<br/>
                    {t('text-start lh-lg-5')}<br/>
                    <a href={`https://ontel-foundation-ltd.gitbook.io/ontel/`} target={`_blank`} className={`d-inline-block bg-transparent bo font-3 border-secondary rounded fw-bold`}>
                        WHITEPAPER
                    </a>
                </p>
            </motion.div>
            <div className={styles.main_bg_1}>
                <div className={styles.main_bg_1_mask}>
                    <motion.img whileInView={{scale:1}} initial={{scale:1.5}} transition={{duration: 0.8,}} src={main_bg_1} alt={``}/>
                </div>

            </div>
            <motion.div
                className={`${styles.main_bg_circle1} box`}
                animation={{scale: [0.2, 0.5, 2, 1, 1]}}
                whileInView={{
                    transition: {
                        duration: 3, ease: "easeInOut", times: [0, 0.2, 0.5, 0.8, 1],
                    }
                }}
            />
            <div className={`${styles.main_bg_circle2} box`}/>
            <motion.div animate={{
                scale: [1.3, 1],
            }} whileHover={{scale: 1.3}} transition={{type: "spring", damping: 1}} className={styles.main_bg_circle3} alt={``}/>
        </div>
        {/*<motion.img className={styles.main_bg_1} src={main_bg_1} alt={``}/>*/}
        <div className={`${styles.sec2_bg} position-relative`} style={{backgroundImage: `url(${main_bg_3})`}}>
            <motion.img whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}} src={platform_img} className={styles.platform_img}/>
            <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}} className={styles.platform_box}>
                <h3 className={`mb-4`}>ONTEL Platform
                </h3>
                <p className={`mb-5`}>
                    {t('ontel-platform-1')}<br/>
                    {t('ontel-platform-2')}<br/>
                    {t('ontel-platform-3')}<br/>
                    {t('ontel-platform-4')}<br/>
                    <br/>
                    {t('ontel-platform-5')}<br/>
                    {t('ontel-platform-6')}
                </p>
                <p>
                    <img alt={`img`} src={icon_check_ye}/>{t('ontel-platform-chk-1')}
                </p>
                <p>
                    <img alt={`img`} src={icon_check_ye}/>{t('ontel-platform-chk-2')}
                </p>
                <p>
                    <img alt={`img`} src={icon_check_ye}/>{t('ontel-platform-chk-3')}
                </p>
            </motion.div>
            <div className={styles.platform_info}>

                <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}}>
                    <h3>NFT-iD</h3>
                    <p>
                        {t('nft-id')}
                    </p>
                </motion.div>
                <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}}>
                    <h3>bSIM</h3>
                    <p>
                        {t('bsim')}
                    </p>
                </motion.div>
                <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}}>
                    <h3>ON-View</h3>
                    <p>
                        {t('on-view')}
                    </p>
                </motion.div>
                <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}}>
                    <h3>ON-Curation</h3>
                    <p>
                        {t('on-curation')}
                    </p>
                </motion.div>
                <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}}>
                    <h3>ON-QNA</h3>
                    <p>
                        {t('on-qna')}
                    </p>
                </motion.div>
                <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}}>
                    <h3>ON-Market</h3>
                    <p>
                        {t('on-market')}
                    </p>
                </motion.div>
            </div>
            <motion.div whileInView={{
                scale: [0, 1],
                opacity: [0, 1]
            }} transition={{duration: 1,}} className={styles.alliance}>
                <h1>
                    ONTEL Alliance
                </h1>
                <div>
                    <img alt={`img`} src={alliance_01}/>
                    <img alt={`img`} src={alliance_02}/>
                    <img alt={`img`} src={alliance_03}/>
                    <img alt={`img`} src={alliance_04}/>
                    <img alt={`img`} src={alliance_05}/>
                    <img alt={`img`} src={alliance_06}/>
                    <img alt={`img`} src={alliance_07}/>
                    <img alt={`img`} src={alliance_08}/>
                    <img alt={`img`} src={alliance_09}/>
                    <img alt={`img`} src={alliance_10}/>
                </div>
            </motion.div>
            <div className={`${styles.ontel_token}`} style={{backgroundImage: `url(${main_bg_4})`}}>
                <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}} className={`m-auto text-start`}>
                    <h1 className={`mt-5 mb-4 fw-bold`}>
                        ONTEL TOKEN
                    </h1>
                    <p>
                        {t('ontel-token-1')}<br/>
                        {t('ontel-token-2')}<br/>
                        {t('ontel-token-3')}<br/>
                        {t('ontel-token-4')}<br/>
                    </p>
                    <a href={`https://ontel-foundation-ltd.gitbook.io/ontel/ontel-token`} target={`_blank`} className={`d-inline-block bg-transparent bo font-3 border-secondary rounded fw-bold`}>
                        <img alt={`img`} className={`mt-5`} src={arrow2}/>
                    </a>
                </motion.div>
                <div className={`m-auto d-flex justify-content-center position-relative ${styles.card_box} ${styles.card_box_2}`}>
                    <motion.div whileInView={{
                        scale: [0, 1],
                        opacity: [0, 1]
                    }} transition={{duration: 1,}} className={styles.card} style={{backgroundColor: `#0FD1E2`, width: `100%`}}>
                        <h3 className={`fw-bold`}>Token Reward</h3>
                        <p>
                            {t('token-reward-1')}<br/>
                            {t('token-reward-2')}<br/>
                            {t('token-reward-3')}<br/>
                            {t('token-reward-4')}
                        </p>
                        <div>
                            <img alt={`img`} src={icon_tokenreward_1} className={`me-2`} width={`30`}/>
                            <img alt={`img`} src={icon_tokenreward_2} className={`me-2`} width={`30`}/>
                            <img alt={`img`} src={icon_tokenreward_3} className={`me-2`} width={`30`}/>
                            <img alt={`img`} src={icon_tokenreward_4} className={`me-2`} width={`30`}/>
                        </div>
                    </motion.div>
                </div>
                <div className={styles.token_info}>
                    <div>
                        <div className={styles.token_info_img}>
                            <img alt={`img`} src={icon_service_fee} className={`me-2`} width={`65`}/>
                        </div>
                        <div className={styles.token_info_text}>
                            <h3>
                                Platform Service Fee
                            </h3>
                            {t('platform-service-fee')}
                        </div>
                    </div>
                    <div>
                        <div className={styles.token_info_img}>
                            <img alt={`img`} src={icon_game} className={`me-2`} width={`65`}/>
                        </div>
                        <div className={styles.token_info_text}>
                            <h3>
                                Participate in<br/>
                                Community
                            </h3>
                            {t('gov-att-1')}<br/>
                            {t('gov-att-2')}<br/>
                            {t('gov-att-3')}
                        </div>
                    </div>
                    <div>
                        <div className={styles.token_info_img}>
                            <img alt={`img`} src={icon_Alliance} className={`me-2`} width={`65`}/>
                        </div>
                        <div className={styles.token_info_text}>
                            <h3>
                                Alliance<br/>
                                Point Market
                            </h3>
                            {t('all-point-market-1')}<br/>
                            {t('all-point-market-2')}<br/>
                            {t('all-point-market-3')}
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
            <div className={styles.roadmap} id={`Roadmap`}>
                <div className={`${styles.main_bg_circle4} box`}/>
                <div className={`${styles.main_bg_circle5} box`}/>
                <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}} className={styles.roadmap_phone}>
                    <img alt={`img`} src={img_phone}/>
                    <div className={styles.roadmap_title}>
                        <h2>ROAD MAP</h2>
                    </div>
                    <div className={styles.roadmap_text}>
                        <div>
                            <h3>Phase 1</h3>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase1-1')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase1-2')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase1-3')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase1-4')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase1-5')}
                            </p>
                        </div>
                        <div>
                            <h3>Phase 2</h3>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase2-1')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase2-2')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase2-3')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase2-4')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase2-5')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase2-6')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_skbl}/>{t('road-map-phase2-7')}
                            </p>
                        </div>
                        <div>
                            <h3>Phase 3</h3>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase3-1')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase3-2')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase3-3')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase3-4')}
                            </p>
                        </div>
                        <div>
                            <h3>Phase 4</h3>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase4-1')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase4-2')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase4-3')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase4-4')}
                            </p>
                        </div>
                        <div>
                            <h3>Phase 5</h3>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase5-1')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase5-2')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase5-3')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase5-4')}
                            </p>
                            <p>
                                <img alt={`img`} src={icon_check_bk}/>{t('road-map-phase5-5')}
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
            <motion.div whileInView={{opacity:1, y:0}} initial={{opacity:0, y:`30%`}} transition={{duration: 1,}} className={styles.team}>
                <h3>
                    TEAM
                </h3>
                <table>
                    <thead>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <h4>Gavin</h4>
                            <p>CEO</p>
                        </td>
                        <td>
                            <h4>David</h4>
                            <p>CTO</p>
                        </td>
                        <td>
                            <h4>Chris</h4>
                            <p>Developer</p>
                        </td>

                        <td>
                            <h4>Alex</h4>
                            <p>PM</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </motion.div>
        </div>

    </div>);
}

Main.propTypes = {};

Main.defaultProps = {};

export default Main;
